export const cars = [
  {
    id: "recDIFJWOS0E",
    marca: "VOLVO",
    modelo: "XC40",
    color: "RED",
    miles: "30",
    battery: "350",
    accel: "4.2",
    price: 45000,
    mpg: 134,
    mpge: 90,
    hc: 17,
    fc: 55,
    hp: 250,
  },
  {
    id: "rec49TJOERIV",
    marca: "BMW",
    modelo: "IX1",
    color: "RED",
    miles: "80",
    battery: "350",
    accel: "6.3",
    price: 54000,
    mpg: 123,
    mpge: 40,
    hc: 158,
    fc: 16,
    hp: 190,
  },

  {
    id: "recSAJdfdhaO906",

    marca: "HYUNDAI",
    modelo: "IONIQ 6",
    color: "RED",
    miles: "49",
    battery: "350",
    accel: "8.2",
    price: 30000,
    mpg: 110,
    mpge: 82,
    hc: 13,
    fc: 35,
    hp: 209,
  },
  {
    id: "rec8394r3oirjecvv",

    marca: "BMW",
    modelo: "I7",
    color: "RED",
    miles: "89",
    battery: "350",
    accel: "6.2",
    price: 89999,
    mpg: 230,
    mpge: 83,
    hc: 47,
    fc: 25,
    hp: 310,
  },
  {
    id: "recDIHFOESIFHEWOIFHW",

    marca: "SKODA",
    modelo: "ENYAQ-COUPE",
    color: "RED",
    miles: "50",
    battery: "350",
    accel: "7.2",
    price: 15000,
    mpg: 128,
    mpge: 84,
    hc: 14,
    fc: 43,
    hp: 205,
  },
  {
    id: "recSJHDW4EOFIJ",
    marca: "TESLA",
    modelo: "ROADSTER",
    color: "RED",
    miles: "65",
    battery: "350",
    accel: "3",
    price: 50000,
    mpg: 122,
    mpge: 30,
    hc: 16,
    fc: 10,
    hp: 330,
  },

  {
    id: "recBFIE983dvds0J",

    marca: "AUDI",
    modelo: "Q4 E-TRON",
    color: "RED",
    miles: "87",
    battery: "350",
    accel: "3.7",
    price: 101000,
    mpg: 122,
    mpge: 30,
    hc: 47,
    fc: 25,
    hp: 300,
  },
  {
    id: "recSJHDAOid09eOID",

    marca: "MINI",
    modelo: "ELECTRIC",
    color: "RED",
    miles: "45",
    battery: "350",
    accel: "7.3",
    price: 45000,
    mpg: 90,
    mpge: 100,
    hc: 12,
    fc: 25,
    hp: 180,
  },
  {
    id: "recDIUW9OFKJAPPDJSKJSNDokdpa30",

    marca: "BMW",
    modelo: "I3",
    color: "RED",
    miles: "56",
    battery: "350",
    accel: "5.2",
    price: 61800,
    mpg: 130,
    mpge: 20,
    hc: 19,
    fc: 42,
    hp: 360,
  },
  {
    id: "recSKJFHpoidfpewojrp93i",

    marca: "HYUNDAI",
    modelo: "IONIQ 5",
    color: "RED",
    miles: "89",
    battery: "350",
    accel: "7.2",
    price: 25000,
    mpg: 122,
    mpge: 82,
    hc: 16,
    fc: 47,
    hp: 120,
  },
  {
    id: "recDOAJDOdijmfe033j",

    marca: "SUBARU",
    modelo: "SOLTERRA",
    color: "RED",
    miles: "67",
    battery: "350",
    accel: "6.2",
    price: 46000,
    mpg: 122,
    mpge: 30,
    hc: 14,
    fc: 15,
    hp: 205,
  },

  {
    id: "recPWOKEOPIDVSDPF",
    marca: "BMW",
    modelo: "I8",
    color: "RED",
    miles: "86",
    battery: "350",
    accel: "4.2",
    price: 60000,
    mpg: 100,
    mpge: 110,
    hc: 9,
    fc: 20,
    hp: 302,
  },


  {
    id: "recPOO3ETET409RUoij09reuro8943T34",
    marca: "POLESTAR",
    modelo: "3",
    color: "RED",
    miles: "86",
    battery: "350",
    accel: "4.2",
    price: 60000,
    mpg: 100,
    mpge: 110,
    hc: 9,
    fc: 20,
    hp: 302,
  },
  {
    id: "recaPIIJOFeo39riwefnef",

    marca: "TESLA",
    modelo: "MODEL X",
    color: "RED",
    miles: "59",
    battery: "350",
    accel: "3.2",
    price: 800000,
    mpg: 110,
    mpge: 60,
    hc: 19,
    fc: 90,
    hp: 230,
  },
  {
    id: "recOIDJEOIFJaslksc",

    marca: "NISSAN",
    modelo: "ARIYA",
    color: "RED",
    miles: "76",
    battery: "350",
    accel: "5.2",
    price: 90000,
    mpg: 121,
    mpge: 80,
    hc: 15,
    fc: 45,
    hp: 200,
  },

  {
    id: "recODFIJJOjaodu93",

    marca: "KIA",
    modelo: "EV6",
    color: "RED",
    miles: "54",
    battery: "350",
    accel: "8.2",
    price: 30000,
    mpg: 178,
    mpge: 84,
    hc: 10,
    fc: 42,
    hp: 202,
  },

  {
    id: "recDSIJdioeiu902",

    marca: "TOYOTA",
    modelo: "BZ4X",
    color: "RED",
    miles: "97",
    battery: "350",
    accel: "7.2",
    price: 45000,
    mpg: 120,
    mpge: 80,
    hc: 17,
    fc: 45,
    hp: 200,
  },
  {
    id: "recSJFOFIJsfewr3ASA",

    marca: "BMW",
    modelo: "IX",
    color: "RED",
    miles: "67",
    battery: "350",
    accel: "5.2",
    price: 90000,
    mpg: 123,
    mpge: 85,
    hc: 16,
    fc: 46,
    hp: 230,
  },
  {
    id: "recSJFOFIJASA",

    marca: "SKODA",
    modelo: "ENYAQ",
    color: "RED",
    miles: "67",
    battery: "350",
    accel: "5.2",
    price: 90000,
    mpg: 123,
    mpge: 85,
    hc: 16,
    fc: 46,
    hp: 230,
  },
  {
    id: "recKJAFENOFA34234",

    marca: "POLESTAR",
    modelo: "2",
    color: "RED",
    miles: "67",
    battery: "350",
    accel: "5.2",
    price: 90000,
    mpg: 123,
    mpge: 85,
    hc: 16,
    fc: 46,
    hp: 230,
  },
  {
    id: "recOGFUWO48UR2190",

    marca: "MG",
    modelo: "5",
    color: "RED",
    miles: "67",
    battery: "350",
    accel: "5.2",
    price: 90000,
    mpg: 123,
    mpge: 85,
    hc: 16,
    fc: 46,
    hp: 230,
  },
  {
    id: "recOIU48RUI0Q98E01",

    marca: "TESLA",
    modelo: "MODEL 3",
    color: "RED",
    miles: "67",
    battery: "350",
    accel: "5.2",
    price: 90000,
    mpg: 123,
    mpge: 85,
    hc: 16,
    fc: 46,
    hp: 230,
  },
  {
    id: "rec8R938YR2E2",

    marca: "RIVIAN",
    modelo: "R1T",
    color: "RED",
    miles: "67",
    battery: "350",
    accel: "5.2",
    price: 90000,
    mpg: 123,
    mpge: 85,
    hc: 16,
    fc: 46,
    hp: 230,
  },
  {
    id: "rec04ERJPÑWEJFPVBWD",

    marca: "PORSCHE",
    modelo: "TAYCAN CROSS TURISMO",
    color: "RED",
    miles: "67",
    battery: "350",
    accel: "5.2",
    price: 90000,
    mpg: 123,
    mpge: 85,
    hc: 16,
    fc: 46,
    hp: 230,
  },


  {
    id: "rec09U4TJIJPWOEIR093RU2",

    marca: "GENESIS",
    modelo: "GV60",
    color: "RED",
    miles: "67",
    battery: "350",
    accel: "5.2",
    price: 90000,
    mpg: 123,
    mpge: 85,
    hc: 16,
    fc: 46,
    hp: 230,
  },
  {
    id: "recR9FU2049R83RO",

    marca: "FORD",
    modelo: "F-150 LIGHTNING",
    color: "RED",
    miles: "67",
    battery: "350",
    accel: "5.2",
    price: 90000,
    mpg: 123,
    mpge: 85,
    hc: 16,
    fc: 46,
    hp: 230,
  },
  {
    id: "rec98d09wuq93q3wholqd",

    marca: "CADILLAC",
    modelo: "LYRIQ",
    color: "RED",
    miles: "67",
    battery: "350",
    accel: "5.2",
    price: 90000,
    mpg: 123,
    mpge: 85,
    hc: 16,
    fc: 46,
    hp: 230,
  },  {
    id: "rec9rjrgnsIDOSN",

    marca: "LOTUS",
    modelo: "EVIJA",
    color: "RED",
    miles: "80",
    battery: "350",
    accel: "3.2",
    price: 95000,
    mpg: 110,
    mpge: 90,
    hc: 89,
    fc: 10,
    hp: 500,
  },
  {
    id: "recEIFOA89EHO3J3",

    marca: "PORSCHE",
    modelo: "718 SPYDER",
    color: "RED",
    miles: "78",
    battery: "350",
    accel: "4.1",
    price: 1000000,
    mpg: 129,
    mpge: 20,
    hc: 12,
    fc: 25,
    hp: 600,
  },
  {
    id: "recPWOKEOPIDVS`DPF",

    marca: "BMW",
    modelo: "I4 GRAN COUPE",
    color: "RED",
    miles: "86",
    battery: "350",
    accel: "4.2",
    price: 67000,
    mpg: 110,
    mpge: 120,
    hc: 10,
    fc: 46,
    hp: 302,
  },
  {
    id: "recoewufhw3eoOUFD",
    marca: "MASERATI",
    modelo: "GRAN TURISMO",
    color: "RED",
    miles: "86",
    battery: "350",
    accel: "4.2",
    price: 60000,
    mpg: 100,
    mpge: 110,
    hc: 9,
    fc: 20,
    hp: 302,
  },
  {
    id: "recPOO309RUoij09reuro89839",
    marca: "MASERATI",
    modelo: "MC20",
    color: "RED",
    miles: "86",
    battery: "350",
    accel: "4.2",
    price: 60000,
    mpg: 100,
    mpge: 110,
    hc: 9,
    fc: 20,
    hp: 302,
  },
  {
    id: "recPOO309RUoij09reuro8943T34",
    marca: "MERCEDES-BENZ",
    modelo: "AMG SL",
    color: "RED",
    miles: "86",
    battery: "350",
    accel: "4.2",
    price: 60000,
    mpg: 100,
    mpge: 110,
    hc: 9,
    fc: 20,
    hp: 302,
  },
  {
    id: "recOFDJNFOQJis0pjoen",

    marca: "TESLA",
    modelo: "MODEL S PLAID",
    color: "RED",
    miles: "96",
    battery: "350",
    accel: "2.8",
    price: 80210,
    mpg: 121,
    mpge: 82,
    hc: 17,
    fc: 25,
    hp: 1000,
  },
  {
    id: "recOFKEPWjife80",

    marca: "ACURA",
    modelo: "INTEGRA",
    color: "RED",
    miles: "75",
    battery: "350",
    accel: "7.2",
    price: 45000,
    mpg: 340,
    mpge: 83,
    hc: 13,
    fc: 15,
    hp: 240,
  },
  {
    id: "rec09UFEORWOLFKNHLF",

    marca: "PORSCHE",
    modelo: "TAYCAN",
    color: "RED",
    miles: "67",
    battery: "350",
    accel: "5.2",
    price: 90000,
    mpg: 123,
    mpge: 85,
    hc: 16,
    fc: 46,
    hp: 230,
  },
  {
    id: "rec09U40RJKNFWLODJ3EQ",

    marca: "LUCID",
    modelo: "AIR",
    color: "RED",
    miles: "67",
    battery: "350",
    accel: "5.2",
    price: 90000,
    mpg: 123,
    mpge: 85,
    hc: 16,
    fc: 46,
    hp: 230,
  },
  {
    id: "recEPOFKW93UJ2K",
    title: "VISUALIZE, COSTUMIZE, ACTUALIZE.",
    marca: "MERCEDES BENZ",
    num: 1,
    modelo: " EQS",
    color: "RED",
    miles: "87",
    battery: "350",
    accel: "5.2",
    price: 120000,
    mpg: 150,
    mpge: 83,
    hc: 15,
    fc: 10,
    hp: 300,
    src: require("./components/Hero/images/mercedes-logo.png"),
  },
  {
    id: "recDOEJFijgeo93",
    title: "VISUALIZE, COSTUMIZE, ACTUALIZE.",
    modelo: " ID.4",
    num: 2,
    marca: " VOLKSWAGEN",
    battery: "93",
    range: "382",
    accel: "5.3",
    price: 120000,
    mpg: 150,
    mpge: 83,
    color: "RED",
    hc: 15,
    fc: 10,
    hp: 300,
    src: require("./components/Hero/images/mercedes-logo.png"),
  },
  {
    id: "recODNFofwo0efjajndoqw",
    title: "THE ULTIMATE ALL-ELECTRIC PERFORMANCE SUV.",
    modelo: "MUSTANG MACH-E",
    marca: "FORD",
    color: "RED",
    num: 3,
    battery: "89",
    range: "420",
    accel: "3.2",
    price: 120000,
    mpg: 150,
    mpge: 83,
    hc: 15,
    fc: 10,
    hp: 300,
    src: require("./components/Hero/images/mercedes-logo.png"),
  },
  {
    id: "recASIJDIEDML223",
    title: "LOWER MAINTENANCE. SMARTER CHOICE.",

    num: 4,
    marca: "CUPRA",
    modelo: " BORN",
    color: "RED",
    miles: "86",
    battery: "350",
    accel: "3.2",
    price: 42000,
    mpg: 122,
    mpge: 21,
    hc: 12,
    fc: 19,
    src: require("./components/Hero/images/mercedes-logo.png"),
    hp: 220,
  },
  {
    id: "rec490WOOWDW9UEPQEoijefowi",
    title: "ADVANCED FEACTURES. ENVITROMENT FRIENDLY.",
    modelo: " IONIQ 5",
    marca: "HYUNDAI",
    battery: "92",
    range: "419",
    accel: "4.3",
    num: 5,
    hp: "330",
    price: 120000,
    mpg: 150,
    color: "RED",
    mpge: 83,
    hc: 15,
    fc: 10,
    src: require("./components/Hero/images/mercedes-logo.png"),
  },
];
